import {
  extractBaseSymbol,
  formatChangePercent,
  formatCryptoPrice,
  IInxTickerMarketData,
  isDownwards,
  selectDisplayPrice,
} from '@r-client/republic/data/offerings';

import {
  RWA_TICKER_SYMBOLS,
  SECURITY_TOKENS_TO_EXCLUDE,
} from '../../constants';
import type { ICryptoAssetCardProps } from '../crypto-asset-card/types';
import { CARD_HREF } from './constants';
import { getCryptoAssetDisplay } from './crypto-asset-registry';

export interface ICryptoAssetCardEntry extends ICryptoAssetCardProps {
  /** `marketName` — unique even if INX ever lists the same asset against EUR. */
  id: string;
}

export const toCryptoAssetCardProps = (
  market: IInxTickerMarketData
): ICryptoAssetCardEntry => {
  const symbol = extractBaseSymbol(market.marketName);
  const { name, logoUrl } = getCryptoAssetDisplay(symbol);

  return {
    id: market.marketName,
    href: CARD_HREF,
    symbol,
    name,
    logoUrl,
    price: formatCryptoPrice(selectDisplayPrice(market)),
    change: formatChangePercent(market.percentageChangePast24h),
    changeDirection: isDownwards(market.percentageChangePast24h)
      ? 'down'
      : 'up',
  };
};

/**
 * Maps the feed to card props, preserving the API's order — the rail shows
 * every market it returns unsorted, minus the handful the real-world assets
 * grid owns. Those are dropped here rather than in the component so the empty
 * state is decided on the list that actually renders.
 */
export const toCryptoAssetCards = (
  markets?: IInxTickerMarketData[]
): ICryptoAssetCardEntry[] =>
  markets
    ?.filter(
      (market) =>
        !RWA_TICKER_SYMBOLS.includes(extractBaseSymbol(market.marketName)) &&
        !SECURITY_TOKENS_TO_EXCLUDE.includes(
          extractBaseSymbol(market.marketName)
        )
    )
    .map(toCryptoAssetCardProps) ?? [];
